import { render, staticRenderFns } from "./MacroItem.vue?vue&type=template&id=675162df&scoped=true&"
import script from "./MacroItem.vue?vue&type=script&lang=js&"
export * from "./MacroItem.vue?vue&type=script&lang=js&"
import style0 from "./MacroItem.vue?vue&type=style&index=0&id=675162df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675162df",
  null
  
)

export default component.exports